
import TextField from '@mui/material/TextField';
import { Props } from './types'

export const Input = ({
  sx,
  type,
  id,
  error,
  label,
  placeholder,
  helperText,
  name,
  value,
  fullWidth,
  required,
  disabled,
  size,
  multiline,
  rows,
  inputProps,
  InputLabelProps,
  defaultValue,
  InputProps,
  variant,
  onChange,
  onBlur,
  onKeyDown
}: Props) => {
  return (
    <TextField
      sx={sx}
      type={type}
      size={size}
      name={name}
      placeholder={placeholder}
      error={error}
      required={required}
      disabled={disabled}
      id={id}
      inputProps={inputProps}
      label={label}
      defaultValue={defaultValue}
      value={value}
      helperText={helperText}
      multiline={multiline}
      fullWidth={fullWidth}
      rows={rows}
      InputLabelProps={InputLabelProps}
      InputProps={InputProps}
      variant={variant}
      onChange={onChange}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
    />
  );
}